import { render, staticRenderFns } from "./TreeViewComponent.vue?vue&type=template&id=6bb4c5ca&"
import script from "./TreeViewComponent.vue?vue&type=script&lang=ts&"
export * from "./TreeViewComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports